import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { createTuinaShift, updateTuinaShift } from '@/service/tuina'
import ShiftForm from './ShiftForm'

const clockToMinutes = (v) => {
  if (!v || typeof v.hour !== 'function') return undefined
  return v.hour() * 60 + v.minute()
}

const fromValue = (fields) => {
  const startTime = clockToMinutes(fields.startTime)
  const endTime = clockToMinutes(fields.endTime)
  const restStartTime = clockToMinutes(fields.restStartTime)
  const restEndTime = clockToMinutes(fields.restEndTime)
  const body = {
    storeId: fields.storeId,
    name: fields.name,
    startTime,
    endTime: endTime === 0 ? 1440 : endTime,
    bookable: fields.bookable,
    sortOrder: fields.sortOrder
  }
  if (restStartTime != null) body.restStartTime = restStartTime
  if (restEndTime != null) body.restEndTime = restEndTime
  return body
}

class ShiftModal extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    actType: PropTypes.oneOf(['create', 'edit']),
    record: PropTypes.object,
    onSuccess: PropTypes.func
  }

  static defaultProps = {
    actType: 'create'
  }

  handleOk = async (form) => {
    const { actType, record, onSuccess } = this.props
    const fields = await form.current.validateFields()
    const formatFields = fromValue(fields)

    switch (actType) {
      case 'create':
        await createTuinaShift(formatFields)
        message.success('已新增')
        break
      case 'edit':
        await updateTuinaShift(record.id, {
          ...formatFields,
          id: record.id,
          isDefault: record.isDefault === true
        })
        message.success('已保存')
        break
      default:
        return
    }
    onSuccess()
  }

  render () {
    const { children, actType, record } = this.props
    const shiftName = (record && record.name) || ''
    const title = actType === 'edit' ? `编辑 ${shiftName} 班次` : '新增班次'
    return (
      <WrappedModal
        children={children}
        title={title}
        okText={actType === 'edit' ? '保存' : '新增'}
        okButtonProps={{ size: 'large' }}
        cancelButtonProps={{ size: 'large' }}
        width={560}
        baseComponent={<ShiftForm />}
        baseProps={{ actType, record }}
        onOk={this.handleOk}
      />
    )
  }
}

export default ShiftModal
